import React from 'react';
import './Experience.css';

function Experience() {
  const allSkills = [
    // Frontend Development
    { name: 'HTML5', level: 'Experienced', icon: '🌐', category: 'Frontend Development' },
    { name: 'CSS3', level: 'Experienced', icon: '🎨', category: 'Frontend Development' },
    { name: 'JavaScript', level: 'Experienced', icon: '⚡', category: 'Frontend Development' },
    { name: 'React', level: 'Intermediate', icon: '⚛️', category: 'Frontend Development' },
    { name: 'Bootstrap', level: 'Intermediate', icon: '🅱️', category: 'Frontend Development' },
    { name: 'Tailwind CSS', level: 'Basic', icon: '💨', category: 'Frontend Development' },
    { name: 'jQuery', level: 'Intermediate', icon: '💙', category: 'Frontend Development' },
    
    // Backend Development
    { name: 'Node.js', level: 'Intermediate', icon: '🟢', category: 'Backend Development' },
    { name: 'Express.js', level: 'Intermediate', icon: '🚂', category: 'Backend Development' },
    { name: 'PHP', level: 'Experienced', icon: '🐘', category: 'Backend Development' },
    { name: 'Spring Boot', level: 'Basic', icon: '🍃', category: 'Backend Development' },
    { name: 'REST API', level: 'Intermediate', icon: '🔌', category: 'Backend Development' },
    
    // Programming Languages
    { name: 'C', level: 'Intermediate', icon: '©️', category: 'Programming Languages' },
    { name: 'C++', level: 'Intermediate', icon: '⚙️', category: 'Programming Languages' },
    { name: 'Java', level: 'Intermediate', icon: '☕', category: 'Programming Languages' },
    { name: 'Python', level: 'Experienced', icon: '🐍', category: 'Programming Languages' },
    { name: 'JavaScript', level: 'Experienced', icon: '📜', category: 'Programming Languages' },
    { name: 'TypeScript', level: 'Basic', icon: '📘', category: 'Programming Languages' },
    
    // Database Management
    { name: 'MySQL', level: 'Experienced', icon: '🐬', category: 'Database Management' },
    { name: 'MongoDB', level: 'Intermediate', icon: '🍃', category: 'Database Management' },
    { name: 'PostgreSQL', level: 'Intermediate', icon: '🐘', category: 'Database Management' },
    { name: 'Firebase', level: 'Basic', icon: '🔥', category: 'Database Management' },
    
    // Tools & Technologies
    { name: 'Git', level: 'Experienced', icon: '📁', category: 'Tools & Technologies' },
    { name: 'GitHub', level: 'Experienced', icon: '🐙', category: 'Tools & Technologies' },
    { name: 'VS Code', level: 'Experienced', icon: '💻', category: 'Tools & Technologies' },
    { name: 'Postman', level: 'Intermediate', icon: '📮', category: 'Tools & Technologies' },
    { name: 'Docker', level: 'Basic', icon: '🐳', category: 'Tools & Technologies' },
    { name: 'Linux', level: 'Intermediate', icon: '🐧', category: 'Tools & Technologies' },
    { name: 'Figma', level: 'Basic', icon: '🎨', category: 'Tools & Technologies' },
    { name: 'npm', level: 'Intermediate', icon: '📦', category: 'Tools & Technologies' },
    
    // Frameworks & Libraries
    { name: 'React.js', level: 'Intermediate', icon: '⚛️', category: 'Frameworks & Libraries' },
    { name: 'Express.js', level: 'Intermediate', icon: '🚂', category: 'Frameworks & Libraries' },
    { name: 'Bootstrap', level: 'Intermediate', icon: '🅱️', category: 'Frameworks & Libraries' },
    { name: 'TensorFlow', level: 'Basic', icon: '🧠', category: 'Frameworks & Libraries' },
    { name: 'Pandas', level: 'Intermediate', icon: '🐼', category: 'Frameworks & Libraries' },
    { name: 'NumPy', level: 'Intermediate', icon: '🔢', category: 'Frameworks & Libraries' },
    { name: 'Scikit-learn', level: 'Intermediate', icon: '🤖', category: 'Frameworks & Libraries' },
  ];

  const categories = [
    'Frontend Development',
    'Backend Development', 
    'Programming Languages',
    'Database Management',
    'Tools & Technologies',
    'Frameworks & Libraries'
  ];

  const SkillItem = ({ name, icon }) => (
    <article>
      <div className="skill-icon">{icon}</div>
      <div>
        <h3 className="outfit-semibold">{name}</h3>
      </div>
    </article>
  );

  return (
    <section id="experience">
      <p className="section__text__p1 outfit-semibold">Explore My</p>
      <h1 className="title playfair-display-bold">Skills & Technologies</h1>
      <div className="experience-details-container">
        <div className="skills-unified-container">
          {categories.map((category) => {
            const categorySkills = allSkills.filter(skill => skill.category === category);
            if (categorySkills.length === 0) return null;
            
            return (
              <div key={category} className="skill-category-section">
                <h2 className="category-title outfit-bold">{category}</h2>
                <div className="article-container">
                  {categorySkills.map((skill, index) => (
                    <SkillItem 
                      key={index} 
                      name={skill.name}
                      icon={skill.icon}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <img 
        src="./assets/arrow.png" 
        alt="Arrow icon" 
        className="icon arrow" 
        onClick={() => window.location.href = '#projects'}
      />
    </section>
  );
}

export default Experience;
